'use strict';

var React = require('react');

var SvgNoteMajor = function SvgNoteMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M11.379 0a1.5 1.5 0 0 1 1.06.44l4.122 4.12a1.5 1.5 0 0 1 .439 1.062v12.878a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-17a1.5 1.5 0 0 1 1.5-1.5h6.879zm-5.379 5h4v2h-4v-2zm8 4v2h-8v-2h8zm-8 6v-2h7v2h-7z"
  }));
};

exports.SvgNoteMajor = SvgNoteMajor;
